import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";
import { BeaconDTO } from "../beacons/Beacon";

const PATH = "beacons";

@Injectable({
  providedIn: "root",
})
export class BeaconHandlerService {
  constructor(private APIService: ApiService) {}

  getBeacons(
    masterAccountID: number,
    queryParams?: { page?: number; perPage?: number },
  ) {
    return this.APIService.get(`${PATH}/${masterAccountID}`, {
      params: queryParams,
    });
  }

  getBeacon(masterAccountID: number, beaconID: number) {
    return this.APIService.get(`${PATH}/${masterAccountID}/${beaconID}`);
  }

  deleteBeacon(masterAccountID: number, beaconID: number) {
    return this.APIService.delete(`${PATH}/${masterAccountID}/${beaconID}`);
  }

  postBeacon(masterAccountID: number, beaconDTO: BeaconDTO) {
    return this.APIService.post(`${PATH}/${masterAccountID}`, beaconDTO);
  }

  putBeacon(masterAccountID: number, beaconDTO: BeaconDTO) {
    return this.APIService.put(
      `${PATH}/${masterAccountID}/${beaconDTO.id}`,
      beaconDTO,
    );
  }
}
